module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl1.8a9ef84e8a032c896a9fe0294e8fb679.png";